import { render, staticRenderFns } from "./BusinessOwnership.vue?vue&type=template&id=49640dc4&scoped=true&"
import script from "./BusinessOwnership.vue?vue&type=script&lang=ts&"
export * from "./BusinessOwnership.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessOwnership.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./BusinessOwnership.vue?vue&type=style&index=1&id=49640dc4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49640dc4",
  null
  
)

export default component.exports